import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import type { EgsRoomRow } from '../tabs/egs/previousEgs';

import CopyEgsRoomsRow, { type EgsRoomsChange } from './CopyEgsRoomsRow';

type CopyEgsRoomsStepProps = {
  onRoomsChange: EgsRoomsChange;
  roomNames: Array<string>;
  rows: Array<EgsRoomRow>;
  roomsByNameKey: Record<string, Array<string>>;
};

export default function CopyEgsRoomsStep({ onRoomsChange, roomNames, rows, roomsByNameKey }: CopyEgsRoomsStepProps) {
  return (
    <>
      <Typography sx={{ mt: 2 }} variant="subtitle2">
        Rooms for each extra guest surcharge
      </Typography>
      <Typography color="text.secondary" variant="body2">
        Read from the Salesforce names. Check them, and pick the rooms where none matched.
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Salesforce name</TableCell>
            <TableCell>Guests</TableCell>
            <TableCell>Rooms</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <CopyEgsRoomsRow
              key={row.key}
              onRoomsChange={onRoomsChange}
              roomNames={roomNames}
              row={row}
              rooms={roomsByNameKey[row.key]}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
}
